import { useEffect } from 'react';

export default function MobileStyles() {
  useEffect(() => {
    const style = document.createElement('style');
    style.textContent = `
      @media (max-width: 768px) {
        /* Global spacing */
        section { padding-left: 20px !important; padding-right: 20px !important; }

        /* Stats 2 cols on mobile */
        .stats-grid { grid-template-columns: repeat(2,1fr) !important; }

        /* Services grid single col */
        .services-grid-home { grid-template-columns: 1fr !important; }

        /* From scratch smaller */
        .scratch-h2 { font-size: clamp(36px, 11vw, 64px) !important; }

        /* Contact grid single col */
        .contact-grid { grid-template-columns: 1fr !important; gap: 32px !important; }

        /* Social icons wrap */
        .social-row { flex-wrap: wrap !important; gap: 12px !important; }

        /* Logo loop shorter */
        .logo-loop-item { margin-right: 40px !important; }

        /* Footer single col */
        footer { flex-direction: column !important; text-align: center !important; gap: 8px !important; padding: 24px 20px !important; }

        /* Bento card reset — handled inline in ServicePage */
        .bento-card {
          grid-column: span 1 !important;
          grid-row: span 1 !important;
          min-height: 140px !important;
        }

        /* Process wrap tighter */
        .process-wrap { gap: 6px !important; }

        /* Navbar padding */
        nav { padding: 14px 20px !important; }

        /* Video iframe */
        iframe { height: 200px !important; }

        /* About section */
        .about-video-wrap { max-width: 100% !important; }
      }

      @media (max-width: 480px) {
        /* Very small screens */
        .stats-grid { grid-template-columns: repeat(2,1fr) !important; gap: 8px !important; }
        .stat-number { font-size: 28px !important; }
      }
    `;
    document.head.appendChild(style);
    return () => document.head.removeChild(style);
  }, []);
  return null;
}
